export default __webpack_public_path__ + "static/12-2b98208b458d0e54ebbcf001d7d8aabe.png";